import * as React from "react";
import FormInput from "./FormInput";
import InputProps from "../../../model/form/InputProps";
import { buildClasses } from "../../../utils/classes";
import InputState from "../../../model/form/InputState";

interface PasswordInputProps extends InputProps {
  readOnly?: boolean;
}

interface PasswordInputState {
  mode: ViewMode;
  readOnly: boolean;
}

enum ViewMode {
  PASSWORD,
  CLEARTEXT,
}

export default class PasswordInput extends React.Component<PasswordInputProps, PasswordInputState> {
  constructor(props: PasswordInputProps) {
    super(props);
    this.state = {
      mode: ViewMode.PASSWORD,
      readOnly: props.readOnly ? props.readOnly : false,
    };
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.template = this.template.bind(this);
  }

  template(state: InputState, input) {
    return (
      <div
        className={buildClasses(
          { invalid: () => state.status.invalid && !state.status.pristine },
          "input-group"
        )}
      >
        <label htmlFor={this.props.name}>
          <span>{this.props.label}</span>
          <span className="detail">{this.props.detail}</span>
        </label>
        <div className="group">
          <input
            type={this.state.mode == ViewMode.CLEARTEXT ? "text" : "password"}
            name={this.props.name}
            id={this.props.name}
            placeholder={this.props.placeholder}
            onChange={input.change}
            onBlur={input.dirty}
            value={state.value}
            readOnly={this.state.readOnly}
          />
          <button type="button" tabIndex={-1} className="mode-toggle" onClick={this.toggleViewMode}>
            <i className={this.viewModeIcon()} />
          </button>
        </div>
        <div className="error-message">{state.status.errorMessage}</div>
      </div>
    );
  }

  render() {
    return <FormInput {...this.props} template={this.template} />;
  }

  private toggleViewMode() {
    this.setState((state) => {
      if (state.mode == ViewMode.CLEARTEXT) {
        return { mode: ViewMode.PASSWORD };
      } else {
        return { mode: ViewMode.CLEARTEXT };
      }
    });
  }

  private viewModeIcon() {
    return this.state.mode == ViewMode.PASSWORD ? "ic_eye_closed" : "ic_eye";
  }
}
